import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, RedirectProps, Route } from 'react-router';
import { selectSessionSelector } from '@mm/state/selectors/userSelector';

type Props = {
  component: React.ComponentType<any>;
  path: string;
  exact?: boolean;
  redirectProps: RedirectProps;
};

/**
 * Will redirect if user already authenticated
 * @param props
 * @constructor
 */
export const PublicOnlyRoute = (props: Props) => {
  const session = useSelector(selectSessionSelector);
  const { component: Component, redirectProps, ...rest } = props;

  return (
    <Route
      {...rest}
      render={props =>
        session && !session.isGuest ? (
          <Redirect {...redirectProps} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};
